import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { uploadProfileImage, uploadToCloudinary } from 'modules/clienteling/actions';
import { withConfig } from 'modules/shell/hoc/withConfig';
import styles from './ProfilePicsUpload.style';
import ProfilePicsUpload from './ProfilePicsUpload';

const mapDispatchToProps = (dispatch, { config }) =>
  bindActionCreators(
    {
      uploadToCloudinary: (files, picType) => uploadToCloudinary(config.get('cloudinary'), files, picType),
      uploadProfileImage,
    },
    dispatch,
  );
export default compose(withConfig(), connect(null, mapDispatchToProps), withStyles(styles))(ProfilePicsUpload);
